import {
  Component,
} from "react";
import uiconfig from "CommonState/uiconfig";
import AntragDokumenteWidget from "App/antrag-dokumente-widget";
import antragApi from "Apis/antrag-api";
import {
  Spinner,
} from "CommonComponents/bricks";

@uiconfig
@antragApi.current
export default class AntragAnlagenTab extends Component {
  render() {
    const { currentAntrag } = this.props;

    if (!currentAntrag) {
      return <Spinner />;
    }
    return <div>
      <AntragDokumenteWidget antrag={ currentAntrag } />
    </div>;
  }
}
